module.exports = __webpack_public_path__ + "img/onboarding.262eb14f.png";